import "./CardReport.css"

const CardReport = ({ title, value }: { title: string; value: string | number }) => {
    return (
        <div className="card-report">
            <span className="card-report__title">{title}</span>
            <span className="card-report__value">{value}</span>
        </div>
    )
}

export const CardReportResume = ({
    title1,
    value1,
    title2,
    value2,
}: {
    title1: string
    value1: string | number
    title2: string
    value2: string | number
}) => {
    return (
        <div className="card-report--double">
            <span className="card-report__title">{title1}</span>
            <span className="card-report--double__value">{value1}</span>
            <div className="card-report--resume">
                <span className="card-report--resume__value">{value2}</span>
                <span className="card-report--resume__title">{title2}</span>
            </div>
        </div>
    )
}

const CardReportSub = ({ value, title }: { value?: string | number; title?: string }) => {
    if (value === undefined && !title) {
        return null
    }
    return (
        <div className="card-report--double__sub">
            {value !== undefined && <span className="card-report--resume__value">{value}</span>}
            {title && <span className="card-report--resume__title">{title}</span>}
        </div>
    )
}

export const CardReportDouble = ({
    title1,
    value1,
    title2,
    value2,
    subValue1,
    subTitle1,
    subValue2,
    subTitle2,
}: {
    title1: string
    value1: string | number
    title2: string
    value2: string | number
    subValue1?: string | number
    subTitle1?: string
    subValue2?: string | number
    subTitle2?: string
}) => {
    return (
        <div className="card-report--double">
            <span className="card-report__title">{title1}</span>
            <div className="card-report--double__row">
                <span className="card-report--double__value">{value1}</span>
                <CardReportSub value={subValue1} title={subTitle1} />
            </div>
            <span className="card-report__title">{title2}</span>
            <div className="card-report--double__row">
                <span className="card-report--double__value">{value2}</span>
                <CardReportSub value={subValue2} title={subTitle2} />
            </div>
        </div>
    )
}

export default CardReport
